<!-- 
    模板页
    lovi 2019-5-28
-->
<template>
  <div>
    <div class="w-1200 template">
      <left-nav :navList="navList"></left-nav>
      <div class="right-sidebar">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import LeftNav from "@/components/common/leftNav";
export default {
  name: "wallet",
  components: {
    LeftNav
  },
  data() {
    return {
      navList: [
        {
          path: "/wallet/recharge",
          icon: "icon-recharge",
          name: this.$t("wallet.cashIn")
        },
        {
          path: "/wallet/withdraw",
          icon: "icon-withdraw",
          name: this.$t("wallet.withdraw")
        },
        {
          path: "/wallet/record",
          icon: "icon-record",
          name: this.$t("wallet.rechargeWithdrawRecord")
        },
        {
          path: "/wallet/bankCard",
          icon: "icon-bankCard",
          name: this.$t("bankCard.bankCardManagement")
        }
      ]
    };
  },
  created() {},
  mounted() {},
  computed: {},
  methods: {},
  watch: {},
  beforeDestroy() {}
};
</script>

<style lang="less" scoped>
.template {
  display: flex;
  justify-content: space-between;
  .right-sidebar {
    flex: 1;
    margin-top: 20px;
    padding: 20px;
    background: #fff;
    min-height: calc(100vh - 100px - 20px);
    overflow: hidden;
  }
}
</style>
